export const heroProfile = {
  en: {
    heading: "Jorge Casagrande",
    description: "Full Stack Developer",
    ctaText: "Projects",
    ctaLink: "#projects"
  },
  es: {
    heading: "Jorge Casagrande",
    description: "Desarrollador Full Stack",
    ctaText: "Proyectos",
    ctaLink: "#projects"
  }
};

export const projects = {
  en: [
    {
      id: 1,
      title: "MarketAudit",
      description: "MarketAudit is a comprehensive solution for product and market data collection. With our mobile app, users can efficiently conduct surveys, while the web platform enables survey management, report generation, and real-time data analysis. Perfect for businesses looking to optimize decision-making based on accurate and organized data.",
      image: "Marketaudit",
      link: "project/1",
      longDescription: "MarketAudit is a powerful tool designed to streamline the process of collecting and analyzing market data. The mobile app allows users to perform surveys on the go, while the web platform provides advanced tools for managing surveys, generating reports, and analyzing data in real-time. This solution is ideal for companies aiming to make data-driven decisions and improve operational efficiency.",
      technologies: [
        { name: "React", icon: "devicon-react-original colored" },
        { name: "Node.js", icon: "devicon-nodejs-plain colored" },
        { name: "MongoDB", icon: "devicon-mongodb-plain colored" },
        { name: "Express", icon: "devicon-express-original colored" },
        { name: "SASS", icon: "devicon-sass-original colored" }
      ]
    },
    {
      id: 2,
      title: "Calsa OT",
      description: "Calsa OT is a solution designed to optimize work order management in factories like Calsa. With our mobile app, operators can complete their assigned tasks, track the time spent, and follow the approval flow from their supervisors. The web platform enables administrators to manage work orders, monitor progress, and generate detailed reports. Perfect for companies looking to enhance operational efficiency and process traceability.",
      image: "CalsaOT",
      link: "project/2",
      longDescription: "Calsa OT is a comprehensive solution tailored for factories to manage work orders efficiently. The mobile app empowers operators to complete tasks, log time, and follow approval workflows, while the web platform provides administrators with tools to oversee operations, track progress, and generate insightful reports. This solution enhances productivity and ensures traceability across processes.",
      technologies: [
        { name: "React Native", icon: "devicon-react-original colored" },
        { name: "Firebase", icon: "devicon-firebase-plain colored" },
        { name: "PostgreSQL", icon: "devicon-postgresql-plain colored" },
        { name: "Express", icon: "devicon-express-original colored" },
        { name: "Bootstrap", icon: "devicon-bootstrap-plain colored" }
      ]
    }
  ],
  es: [
    {
      id: 1,
      title: "MarketAudit",
      description: "MarketAudit es una solución integral para el relevamiento de información de productos y mercados. A través de nuestra aplicación móvil, los usuarios pueden realizar relevamientos de manera eficiente, mientras que la plataforma web permite la administración de encuestas, la gestión de informes y el análisis de datos en tiempo real. Ideal para empresas que buscan optimizar la toma de decisiones basadas en datos precisos y organizados.",
      image: "Marketaudit",
      link: "project/1",
      longDescription: "MarketAudit es una herramienta poderosa diseñada para simplificar el proceso de recopilación y análisis de datos de mercado. La aplicación móvil permite a los usuarios realizar encuestas en movimiento, mientras que la plataforma web ofrece herramientas avanzadas para gestionar encuestas, generar informes y analizar datos en tiempo real. Esta solución es ideal para empresas que buscan tomar decisiones basadas en datos y mejorar la eficiencia operativa.",
      technologies: [
        { name: "React", icon: "devicon-react-original colored" },
        { name: "Node.js", icon: "devicon-nodejs-plain colored" },
        { name: "MongoDB", icon: "devicon-mongodb-plain colored" },
        { name: "Express", icon: "devicon-express-original colored" },
        { name: "SASS", icon: "devicon-sass-original colored" }
      ]
    },
    {
      id: 2,
      title: "Calsa OT",
      description: "Calsa OT es una solución diseñada para optimizar la gestión de órdenes de trabajo en fábricas como Calsa. A través de nuestra aplicación móvil, los operarios pueden realizar sus tareas asignadas, registrar el tiempo utilizado y seguir el flujo de aprobación de sus superiores. La plataforma web permite a los administradores gestionar las órdenes de trabajo, supervisar el progreso y generar informes detallados. Ideal para empresas que buscan mejorar la eficiencia operativa y la trazabilidad de sus procesos.",
      image: "CalsaOT",
      link: "project/2",
      longDescription: "Calsa OT es una solución integral diseñada para fábricas que buscan gestionar órdenes de trabajo de manera eficiente. La aplicación móvil permite a los operarios completar tareas, registrar tiempos y seguir flujos de aprobación, mientras que la plataforma web proporciona herramientas para supervisar operaciones, rastrear el progreso y generar informes detallados. Esta solución mejora la productividad y garantiza la trazabilidad en los procesos.",
      technologies: [
        { name: "React Native", icon: "devicon-react-original colored" },
        { name: "Firebase", icon: "devicon-firebase-plain colored" },
        { name: "PostgreSQL", icon: "devicon-postgresql-plain colored" },
        { name: "Express", icon: "devicon-express-original colored" },
        { name: "Bootstrap", icon: "devicon-bootstrap-plain colored" }
      ]
    }
  ]
};

export const projectsSection = {
  en: {
    title: "Projects",
    description:
      "Explore some of the projects I've worked on, designed to solve complex problems and optimize processes. Each project combines innovation, functionality, and design to deliver effective and tailored solutions."
  },
  es: {
    title: "Proyectos",
    description:
      "Explora algunos de los proyectos en los que he trabajado, diseñados para resolver problemas complejos y optimizar procesos. Cada proyecto combina innovación, funcionalidad y diseño para ofrecer soluciones efectivas y personalizadas."
  }
};

export const personalInfo = {
  en: {
    name: "Jorge Casagrande",
    title: "Full Stack Developer",
    description: "I specialize in building dynamic and scalable web applications that combine functionality, performance, and user-friendly design. With a passion for solving real-world problems, I aim to deliver impactful digital experiences tailored to the needs of users."
  },
  es: {
    name: "Jorge Casagrande",
    title: "Desarrollador Full Stack",
    description: "Me especializo en la creación de aplicaciones web dinámicas y escalables que combinan funcionalidad, rendimiento y diseño intuitivo. Con pasión por resolver problemas del mundo real, mi objetivo es ofrecer experiencias digitales impactantes adaptadas a las necesidades de los usuarios."
  }
};

export const aboutSection = {
  en: {
    title: "About Me",
    description:
      "Learn more about me, my experience as a Full Stack Developer, and my passion for creating innovative digital solutions. I strive to combine intuitive design, functionality, and performance to deliver impactful experiences."
  },
  es: {
    title: "Sobre Mí",
    description:
      "Descubre más sobre mí, mi experiencia como desarrollador Full Stack y mi pasión por crear soluciones digitales innovadoras. Me esfuerzo por combinar diseño intuitivo, funcionalidad y rendimiento para ofrecer experiencias impactantes."
  }
};

export const contactSection = {
  en: {
    title: "Contact",
    description:
      "Have a project in mind or just want to say hi? Feel free to get in touch with me. I'm available to collaborate on exciting projects and solve problems with innovative solutions."
  },
  es: {
    title: "Contacto",
    description:
      "¿Tienes un proyecto en mente o simplemente quieres saludar? No dudes en ponerte en contacto conmigo. Estoy disponible para colaborar en proyectos interesantes y resolver problemas con soluciones innovadoras."
  }
};

export const footerContent = {
  en: {
    socialText: "Social",
    description: "Full stack developer focused on Backend with .NET, databases, and a passion for building efficient solutions.",
    copyright:
      "© 2025 Jorge Casagrande. All rights reserved."
  },
  es: {
    socialText: "Social",
    description: "Desarrollador full stack enfocado en Backend con .NET, bases de datos y pasión por crear soluciones eficientes.",
    copyright:
      "© 2025 Jorge Casagrande. Todos los derechos reservados."
  }
};

export const aboutPage = {
  en: {
    hero: {
      title: "Jorge Casagrande",
      description: "I am a passionate Full Stack Developer with experience in building scalable web applications and solving complex problems with efficient solutions."
    },
    skillsTitle: "Skills",
    experienceTitle: "Experience",
    experience: [
      {
        image: 'sovos-logo.png',
        title: 'Sr Software Engineer - Sovos',
        skills: ['.Net','.Net Core', 'C#', 'React','JavaScript', 'Postgres SQL', 'Azure','Git'],
        description: 'Developed scalable web applications and APIs.',
      },
      {
        image: 'advertmind-logo.png',
        title: 'Full stack Developer - Advertmind',
        skills: ['.Net','.Net Core', 'C#', 'Angular','JavaScript', 'SQL Server'],
        description: 'Created responsive user interfaces with React.',
      },
      {
        image: 'practia-logo.png',
        title: 'Ssr Software Engineer - Practia',
        skills: ['.Net','.Net Core', 'C#', 'Angular','JavaScript', 'Postgres SQL'],
        description: 'Built RESTful APIs and managed database operations.',
      },
      {
        image: 'everis-logo.png',
        title: 'Ssr Software Engineer - Everis',
        skills: ['React', 'Node.js', 'MongoDB'],
        description: 'Developed scalable web applications and APIs.',
      },
      {
        image: 'dime-logo.png',
        title: 'Jr Software Developer - Advertmind',
        skills: ['React', 'CSS', 'JavaScript'],
        description: 'Created responsive user interfaces with React.',
      }
    ],
    interestingFacts: [
      {
        title: "Interesting Facts",
        description: "I love solving challenging problems, learning new technologies, and collaborating with teams to build impactful projects."
      }
      // Puedes agregar más objetos aquí
    ]
  },
  es: {
    hero: {
      title: "Jorge Casagrande",
      description: "Soy un apasionado Desarrollador Full Stack con experiencia en la creación de aplicaciones web escalables y en la resolución de problemas complejos con soluciones eficientes."
    },
    skillsTitle: "Skills",
    experienceTitle: "Experiencia",
    experience: [
      {
        image: 'sovos-logo.png',
        title: 'Sr Software Engineer - Sovos',
        skills: ['React', 'Node.js', 'MongoDB'],
        description: 'Desarrollé aplicaciones web escalables y APIs.',
      },
      {
        image: 'advertmind-logo.png',
        title: 'Full stack Developer - Advertmind',
        skills: ['React', 'CSS', 'JavaScript'],
        description: 'Creé interfaces de usuario responsivas con React.',
      },
      {
        image: 'practia-logo.png',
        title: 'Full stack Developer - Practia',
        skills: ['Node.js', 'Express', 'PostgreSQL'],
        description: 'Construí APIs RESTful y gestioné operaciones de bases de datos.',
      },
    ],
    interestingFacts: [
      {
        title: "Datos de Interés",
        description: "Me encanta resolver problemas desafiantes, aprender nuevas tecnologías y colaborar con equipos para construir proyectos impactantes."
      }
      // Puedes agregar más objetos aquí
    ]
  }
};

export const skills = {
  en: [
    ".NET",
    ".NET Core",
    "C#",
    "JavaScript",
    "HTML",
    "React",
    "Angular",
    "GIT",
    "SQL Server",
    "PostgreSQL"
  ],
  es: [
    ".NET",
    ".NET Core",
    "C#",
    "JavaScript",
    "HTML",
    "React",
    "Angular",
    "GIT",
    "SQL Server",
    "PostgreSQL"
  ]
};